import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const Breadcrumbs = ({ items = [] }) => {
    return (
        <nav
            aria-label="Breadcrumb"
            data-testid="breadcrumbs"
            className="flex items-center gap-1.5 text-sm text-stone-500 flex-wrap"
        >
            <Link
                to="/"
                className="inline-flex items-center gap-1 hover:text-brand-700 transition-colors"
            >
                <Home className="h-3.5 w-3.5" />
                <span>Home</span>
            </Link>
            {items.map((it, i) => (
                <span key={i} className="flex items-center gap-1.5">
                    <ChevronRight className="h-3.5 w-3.5 text-stone-400" />
                    {it.to && i < items.length - 1 ? (
                        <Link
                            to={it.to}
                            className="hover:text-brand-700 transition-colors"
                        >
                            {it.label}
                        </Link>
                    ) : (
                        <span className="text-stone-800 font-medium">
                            {it.label}
                        </span>
                    )}
                </span>
            ))}
        </nav>
    );
};
